var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-progress',{staticStyle:{"width":"100%"},attrs:{"percent":_vm.value,"color":_vm.getColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }